import styled, { css } from 'styled-components';
import { IButtonProps } from '../../eventToolbox/EventToolbox.styles';

export const StyledButton = styled.button<IButtonProps>`
    font-size: 1em;
    margin: 3px;
    padding: 0.5em 1.5em;
    border-radius: 4px;
    outline: none;
    cursor: pointer;

    @media only screen and (max-width: 1280px) {
        font-size: 0.8rem;
        padding: 0.4em 0.8em;
    }

    ${({ isSelected }) =>
        !isSelected &&
        css`
            opacity: 0.25;
        `}
`;

export const MoveButton = styled.button<IButtonProps>`
    cursor: pointer;

    &.is-moved-to {
        cursor: pointer;
        background: transparent;
        border: 0;
        color: purple;
        font-size: 0.85rem;
    }

    ${({ isSelected }) =>
        isSelected &&
        css`
            background: red;
            border: red;
            color: #fff;
        `}
`;

export const MoveMsg = styled.div`
    display: flex;
    flex-direction: column;
    position: absolute;
    right: 0;
    bottom: -100px;
    border: 1px solid #ddd;
    border-radius: 5px;
    background: #ccc;
    z-index: 1;
    height: 100px;
    width: 75%;
`;

export const MoveMsgText = styled.div`
    display: flex;
    flex-grow: 1;
    flex-basis: 0;
    max-height: 50%;
    flex: 0 0 0 50%;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    padding-left: 10px;
    padding-top: 7px;
    font-size: 0.75rem;
    font-weight: 400;
`;

export const MoveMsgBtn = styled.div`
    display: flex;
    flex-grow: 1;
    flex-basis: 0;
    max-height: 50%;
    flex: 0 0 0 50%;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 5px;
`;
